
<ng-container *ngIf="isDate; else elseTemplate">
    {{displayfield?.toDate() | date}}    
</ng-container>
<ng-template #elseTemplate>
    {{displayfield}}    
</ng-template>
